import { FC, HTMLAttributes } from 'react';

export const ReactComponent: FC<HTMLAttributes<SVGElement>> = (props) => (
  <svg
    {...props}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 10C6.55228 10 7 10.4477 7 11V12L18 12C18.5523 12 19 12.4477 19 13C19 13.5523 18.5523 14 18 14L7 14V15C7 15.5523 6.55228 16 6 16C5.44772 16 5 15.5523 5 15V14H2C1.44772 14 1 13.5523 1 13C1 12.4477 1.44772 12 2 12H5V11C5 10.4477 5.44772 10 6 10ZM14 4C14.5523 4 15 4.44772 15 5V9C15 9.55228 14.5523 10 14 10C13.4477 10 13 9.55228 13 9V5C13 4.44772 13.4477 4 14 4Z"
      fill="#24275B"
    />
    <rect x="19" y="6" width="2" height="18" rx="1" transform="rotate(90 19 6)" fill="#24275B" />
  </svg>
);
